import { html, nothing, TemplateResult } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import LocationTypeaheadComponent from '@components/typeahead/location';
import EmailTypeaheadComponent from '@components/typeahead/email';
import LawComplianceComponent from "@components/lawcompliance";
import SocialButtonsTemplate from "./socialButtons";
import StatementDescriptionTemplate from "./statementDescription";
import ButtonField from '../buttonField';
import WhatField from '../whatField';


const FormTemplate = async (config: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {
  const {
    isEmptySearch,
    messages,
    captcha: {
      enabled: captchaEnabled
    },
    feature: {
      whatFieldInModalPopupEnabled = false,
      distanceFilterEnabled = false,
      locationFieldInModalPopupEnabled = false,
    },
    subscription: {
      buttonAdditionalClass
    },
    page: {
      isJobPreviewPage
    },
    socialLogin
  } = config;
  const {
    loading,
    handleSubmit,
    handleWhatInput,
    handleWhereInput,
    handleEmailChange,
    handleSocialSubmit,
    handleClearWhatInput,
    formData,
    description = '',
    formSubmitted,
  } = model;
  const formClasses = {
    'no-distance-filter': !distanceFilterEnabled,
    'proposal-form--empty-search': !formData.what.value && !formData.where.value
  };
  const whatFieldParams: IWhatField = {
    loading,
    messages,
    formData,
    handleWhatInput,
    handleClearWhatInput,
  };
  const emailTypeaheadProps: IEmailTypeaheadProps = {
    placeholder: messages.JobSeekerSubscriptionDialogEmailLabel,
    labelText: messages.JobSeekerSubscriptionDialogEmailLabel,
    providersLimit: 5,
    onEmailChange: handleEmailChange
  }
  const submitButtonParams: ISubmitButton = {
    loading,
    additionalClass: buttonAdditionalClass,
    messages,
  }

  const isWhatFieldEnabled = whatFieldInModalPopupEnabled || isEmptySearch || isJobPreviewPage;
  const isWhereFieldEnabled = locationFieldInModalPopupEnabled || isEmptySearch || isJobPreviewPage;

  const formFieldClasses = {
    'proposal-form__field--error': formSubmitted && !formData.email?.isValid
  };

  const locationTypeaheadPlaceholder = locationFieldInModalPopupEnabled && !isEmptySearch && !isJobPreviewPage
    ? messages.ProposalPopupLocationPlaceholder
    : messages.SearchWhere;

  const isLocationLabelEnabled = (locationFieldInModalPopupEnabled || isEmptySearch) && !isJobPreviewPage;

  const locationTypeaheadProps: ILocationTypeaheadProps = {
    isLocationLabelEnabled,
    locationValue: formData.where.value,
    locationTypeaheadFor: 'proposal-modal',
    placeholder: locationTypeaheadPlaceholder,
    cssClasses: 'jr-input jr-input--autocomplete jr-input-material',
    labelText: messages.ProposalPopupLocationLabel,
    onLocationChange: handleWhereInput,
  }

  const lawComplianceProps: ILawComplianceComponent = {
    messages,
    captchaEnabled
  }

  return html`
    <div class="modal-body">
      <div class="proposal-claim">
        <div class="description-wrapper">
          ${StatementDescriptionTemplate(description)}
        </div>
      </div>
      <form class="proposal-form ${classMap(formClasses)}" name="forms.proposal" novalidate @submit=${handleSubmit}>
      <div class="proposal-form--error-message">
          <span>${unsafeHTML(messages.JobSeekerSubscriptionDialogInvalidWLWarn)}</span>
      </div>
      <div class="proposal-form__box"> 
          ${isWhatFieldEnabled ? WhatField(whatFieldParams) : nothing}
          ${isWhereFieldEnabled ?
      html`<div class="proposal-form__field">
            ${await LocationTypeaheadComponent(locationTypeaheadProps)}
            </div>
            `
      : nothing}
        </div>
        <div class="proposal-form__field ${classMap(formFieldClasses)}">
          <div class="proposal-form--error-message">
            <span>${messages.JobSeekerSubscriptionDialogInvalidEmailWarn}</span>
          </div>
          <div class="email-typeahead-container">
            ${EmailTypeaheadComponent(emailTypeaheadProps)}
          </div>
        </div>
        ${captchaEnabled ? html`<div id="modal-captcha-container"></div>` : nothing}
        ${ButtonField(submitButtonParams)}
      </form>
      ${LawComplianceComponent(lawComplianceProps)}
      ${socialLogin.enabled && socialLogin.insidePopupEnabled && handleSocialSubmit ? SocialButtonsTemplate({ messages, captchaEnabled, socialLogin, handleSocialSubmit }) : nothing}
      </div>`;
}

export default FormTemplate;